import {message, Popconfirm, Space} from "antd";
import React, {FC, useState} from "react";
import TaxCaseStore from "../contexts/taxCaseStore";
import _t from "../lang/translate";
import {acceptTaxOffer, paidTaxOffer, uploadedTaxOffer} from "../services/taxService";
import {isAxiosError} from "../utilities/typeGuard";
import CheckButton from "./form/checkButton";

interface TaxFlagsSwitchesProps {
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
}

const TaxFlagsSwitches: FC<TaxFlagsSwitchesProps> = ({ setLoading }) => {
  const { taxCase, setTaxCase } = TaxCaseStore.useContainer();
  const [loadingAccept, setLoadingAccept] = useState(false)
  const [loadingDocuments, setLoadingDocuments] = useState(false)
  const [loadingPaid, setLoadingPaid] = useState(false)

  const handleDocumentsUploaded = async (v: boolean) => {
    try {
      setLoading(true);
      setLoadingDocuments(true)
      const { data } = await uploadedTaxOffer(taxCase.id, { status: v });
      message.success(_t(v ? "documents_uploaded" : "documents_not_uploaded"));
      setTaxCase(data);
    } catch (error) {
      const errorMessage = isAxiosError(error) ? error.response?.data?.message : null;
      message.error(errorMessage || _t("msg.unknown_error"));
    } finally {
      setLoading(false);
      setLoadingDocuments(false)
    }
  };

  const handleOfferAccept = async (v: boolean) => {
    try {
      setLoading(true);
      setLoadingAccept(true)
      const { data } = await acceptTaxOffer(taxCase.id, { status: v });
      message.success(_t(v ? "accepted" : "not_accepted"));
      setTaxCase(data);
    } catch (error) {
      const errorMessage = isAxiosError(error) ? error.response?.data?.message : null;
      message.error(errorMessage || _t("msg.unknown_error"));
    } finally {
      setLoading(false);
      setLoadingAccept(false)
    }
  };

  const handleInvoicePaid = async (v: boolean) => {
    try {
      setLoading(true);
      setLoadingPaid(true)
      const { data } = await paidTaxOffer(taxCase.id, { status: v });
      message.success(_t(v ? "invoice_paid" : "invoice_not_paid"));
      setTaxCase(data);
    } catch (error) {
      const errorMessage = isAxiosError(error) ? error.response?.data?.message : null;
      message.error(errorMessage || _t("msg.unknown_error"));
    } finally {
      setLoading(false);
      setLoadingPaid(false)
    }
  };

  return (
    <Space wrap>
      <Popconfirm title={_t("confirm_action")} onConfirm={() => handleOfferAccept(!taxCase.flags.accepted)}>
        <CheckButton checked={taxCase.flags.accepted} loading={loadingAccept}>
          {_t("case", "accepted")}
        </CheckButton>
      </Popconfirm>
      <CheckButton checked={taxCase.flags.uploaded} onClick={() => handleDocumentsUploaded(!taxCase.flags.uploaded)} loading={loadingDocuments}>
        {_t("documents", "received")}
      </CheckButton>
      <CheckButton checked={taxCase.flags.paid} onClick={() => handleInvoicePaid(!taxCase.flags.paid)} loading={loadingPaid}>
        {_t("payment", "received")}
      </CheckButton>
    </Space>
  );
};

export default TaxFlagsSwitches;
